const E = "flex", e = {
  ROW: "row",
  COLUMN: "column",
  ROW_REVERSE: "row-reverse",
  COLUMN_REVERSE: "column-reverse"
}, R = {
  NORMAL: "normal",
  FLEX_START: "flex-start",
  FLEX_END: "flex-end",
  CENTER: "center",
  SPACE_AROUND: "space-around",
  SPACE_EVENLY: "space-evenly",
  SPACE_BETWEEN: "space-between"
}, r = {
  NORMAL: "normal",
  FLEX_START: "flex-start",
  FLEX_END: "flex-end",
  START: "start",
  END: "end",
  CENTER: "center",
  STRETCH: "stretch",
  BASELINE: "baseline"
}, N = {
  NORMAL: "normal",
  FLEX_START: "flex-start",
  FLEX_END: "flex-end",
  CENTER: "center",
  SPACE_AROUND: "space-around",
  SPACE_BETWEEN: "space-between",
  STRETCH: "stretch"
}, _ = {
  WRAP: "wrap",
  NO_WRAP: "nowrap",
  WRAP_REVERSE: "wrap-reverse"
};
export {
  N as FLEX_ALIGN_CONTENT,
  r as FLEX_ALIGN_ITEMS,
  E as FLEX_BASE_CLASS,
  e as FLEX_DIRECTION,
  R as FLEX_JUSTIFY_CONTENT,
  _ as FLEX_WRAP
};
